export default "__VITE_ASSET__ChAOqeE4__"